"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _Text = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Text"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _renderTypography = _interopRequireDefault(require("./renderTypography"));
var _renderFootnoteLinks = _interopRequireDefault(require("./renderFootnoteLinks"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectFootnoteContainer = _ref => {
  let {
    footnoteMarginTop
  } = _ref;
  return {
    marginTop: footnoteMarginTop
  };
};
const selectFootnoteBottomTextContainer = _ref2 => {
  let {
    bottomTextMarginTop
  } = _ref2;
  return {
    marginTop: bottomTextMarginTop
  };
};
const selectFootnoteLinksStyles = _ref3 => {
  let {
    bottomLinksMarginLeft
  } = _ref3;
  return {
    marginLeft: bottomLinksMarginLeft
  };
};
const renderFootnoteContent = (footnoteMarginTop, bottomTextMarginTop, bottomText, bottomTextTypographyTokens, fontColor, footnoteLinks, bottomLinksMarginLeft, onClickFootnote, themeTokens) => {
  const MAX_FOOTNOTE_LINKS_ALLOWED = 3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: [staticStyles.footnoteContainer, selectFootnoteContainer({
        footnoteMarginTop
      })],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        style: selectFootnoteBottomTextContainer({
          bottomTextMarginTop
        }),
        children: [(0, _renderTypography.default)(bottomText, bottomTextTypographyTokens, undefined, fontColor), ' ']
      }), footnoteLinks?.length <= MAX_FOOTNOTE_LINKS_ALLOWED ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
        style: [staticStyles.footnoteLinkContainer, selectFootnoteLinksStyles({
          bottomLinksMarginLeft
        })],
        children: (0, _renderFootnoteLinks.default)(footnoteLinks, themeTokens, onClickFootnote)
      }) : null]
    }), footnoteLinks?.length > MAX_FOOTNOTE_LINKS_ALLOWED ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: staticStyles.verticalFootnoteLinkContainer,
      children: (0, _renderFootnoteLinks.default)(footnoteLinks, themeTokens, onClickFootnote)
    }) : null]
  });
};
var _default = exports.default = renderFootnoteContent;
const staticStyles = _StyleSheet.default.create({
  footnoteContainer: {
    flexDirection: 'row'
  },
  footnoteLinkContainer: {
    flexDirection: 'row',
    ..._Platform.default.select({
      ios: {
        alignSelf: 'flex-end',
        top: 2
      },
      android: {
        alignSelf: 'center',
        top: -8
      }
    })
  },
  verticalFootnoteLinkContainer: {
    ..._Platform.default.select({
      ios: {
        top: 10
      },
      android: {
        top: -2
      }
    })
  }
});